import script from "./CarteleraLotes.vue?vue&type=script&setup=true&lang=js"
export * from "./CarteleraLotes.vue?vue&type=script&setup=true&lang=js"

import "./CarteleraLotes.vue?vue&type=style&index=0&id=0a2ff69e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a2ff69e"]])

export default __exports__